const LOCAL_STORAGE = {
  ACCESS_TOKEN: 'ONECMS_AccessToken',
  REFRESH_TOKEN: 'ONECMS_RefreshToken',
  ABILITIES: 'ONECMS_Abilities',
  LANGUAGE: 'ONECMS_Language',
  PREVIEW_DATA: 'ONECMS_PreviewData',
  FINDER_TREE_SELECTED: 'ONECMS_TreeSelected',
  BLOCKED_POPUPS: 'ONECMS_BlockedPopups',
};

export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const COLORS = {
  COOL_BLACK: '#002b60',
};

export const DEFAULT_QUERY_OPTION = {
  retry: 0,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};

export const URL_CONST = {
  MEDIA_FILE_UPLOAD_CHUNK: 'api/v1/media-files/upload-chunk',
  MEDIA_FILE_MERGE_CHUNK: 'api/v1/media-files/merge-chunk',
  FILE_UPLOAD_CHUNK: 'api/v1/files/upload-chunk',
  FILE_MERGE_CHUNK: 'api/v1/files/merge-chunk',
};

export const TARGET_LIST_OPTIONS = [
  {
    label: 'Mở liên kết trong tab hiện tại',
    value: 1,
  },
  {
    label: 'Mở liên kết trong tab mới',
    value: 2,
  },
];
export const TARGET_LIST_LABEL = [
  {
    label: '_self',
    value: 1,
  },
  {
    label: '_blank',
    value: 2,
  },
];

export const socialList: OptionType[] = [
  {
    label: 'Facebook',
    value: 1,
  },
  {
    label: 'Twitter',
    value: 2,
  },
];

export const newsListSortBy: OptionType[] = [
  {
    label: 'Thứ tự hiển thị',
    value: 'displayOrder',
  },
  {
    label: 'Ngày đăng',
    value: 'displayOrder',
  },
];

export const newsListSortType: OptionType[] = [
  {
    label: 'Ascending',
    value: 'asc',
  },
  {
    label: 'Descending',
    value: 'desc',
  },
];

export default LOCAL_STORAGE;

export const INTEGER_REGEX = /^[+-]?((\d*\.?\d+(?:[Ee][+-]?\d+)?)|(\d+\.))$/;
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_REGEX = /^0[1-9][0-9]{8}$/;

export const ROUTE_PATHS = {
  /* BLOCK TEMPLATE */
  PAGE_TEMPLATE_MANAGEMENT: '/page-templates',
  /* PAGE */
  PAGE_MANAGEMENT: '/page-management',
  PAGE_DETAIL: '/page',
  /* FILE */
  FILE_MANAGEMENT: '/files-management',
  /* MENU */
  MENU_MANAGEMENT: '/menu-management',
  MENU_DETAIL: '/menu',
  /* NEWS */
  NEWS_MANAGEMENT: '/news-management',
  NEWS_DETAIL: '/news',
  NEWS_CATEGORY_MANAGEMENT: '/news-category-management',
  NEWS_CATEGORY_DETAIL: '/news-category',
  /* BANNER */
  BANNER_MANAGEMENT: '/banner-management',
  BANNER_DETAIL: '/banner',
  /* TRANSLATIONS */
  FE_TRANSLATION_MANAGEMENT: '/fe-translation',
  CMS_TRANSLATION_MANAGEMENT: '/cms-translation',
  /* REDIRECT */
  REDIRECT_MANAGEMENT: '/redirect',
  REDIRECT_IMPORT: '/redirect-import',
  /* ACTIVITY */
  ACTIVITY_MANAGEMENT: '/activity-logs',
  /* ROLES */
  ROLES_MANAGEMENT: '/roles',
  ROLES_DETAIL: '/role-detail',
  /* USERS */
  USERS_MANAGEMENT: '/users-management',
  USERS_DETAIL: '/user',
  /* FAQ */
  FAQ_MANAGEMENT: '/faq-management',
  FAQ_DETAIL: '/faq',
  FAQ_CATEGORY_MANAGEMENT: '/faq-category-management',
  FAQ_CATEGORY_DETAIL: '/faq-category',
  /* CONFIG */
  SYSTEM_MANAGEMENT: '/system',
  SYSTEM_CONFIG_MANAGEMENT: '/config-management',
  ERRORS_MANAGEMENT: '/errors-management',
  /* AUTH */
  LOGIN: '/login',
  /* CONTACT */
  CONTACT_MANAGEMENT: '/contact-management',
  CONTACT_PROBLEM_MANAGEMENT: '/contact-problem-management',
  CONTACT_PROBLEM_DETAIL: '/contact-problem-detail',
  /* EMAIL TEMPLATE */
  EMAIL_TEMPLATE_MANAGEMENT: '/email-template-management',
  EMAIL_TEMPLATE_DETAIL: '/email-template-detail',
  /* FORM */
  FORM_MANAGEMENT: '/form-management',
  FORM_DETAIL: '/form-detail',
  SUBMIT_FORM_MANAGEMENT: '/submit-form-management',
  SUBMIT_FORM_LIST_BY_FORM: '/submit-form-list-by-form',
  /* STATIC BLOCK */
  STATIC_BLOCK_MANAGEMENT: '/static-block-management',
  STATIC_BLOCK_DETAIL: '/static-block-detail',
  /* PROGRAM */
  PROGRAM_MANAGEMENT: '/program-management',
  PROGRAM_DETAIL: '/program-detail',
  PROJECT_TIMESHEET_DETAIL: '/program-timesheet-detail',
  SALARY_PROGRAM_DETAIL: '/salary-program-detail',
  /* EMPLOYEE */
  EMPLOYEE_MANAGEMENT: '/employee-management',
  EMPLOYEE_DETAIL: '/employee-detail',
  /* BANK */
  BANK_MANAGEMENT: '/bank-management',
  BANK_DETAIL: '/bank-detail',
  /* TIMEKEEPING */
  TIMEKEEPING_MANAGEMENT: '/timekeeping-management',
  TIMEKEEPING_DETAIL_INFO_MANAGEMENT: '/timekeeping-detail-info-management',
  /* STUDENTS */
  STUDENTS_MANAGEMENT: '/students-management',
  STUDENTS_DETAIL: '/students-detail',
  /* EMPLOYEE IMPORT */
  EMPLOYEE_IMPORT: '/employee-import',
  /* TIMESHEET */
  TIMESHEET_MANAGEMENT: '/timesheet-management',
  TIMESHEET_DETAIL: '/timesheet-detail',
  TIMEKEEPING_DETAIL: '/timekeeping-detail',
  /* SALARY CALCULATION */
  SALARY_CALCULATE_MANAGEMENT: '/salary-calculate-management',
  SALARY_CALCULATE_DETAIL: '/salary-calculate-detail',
  SALARY_CALCULATE_PERIOD_DETAIL: '/salary-calculate-period-detail',
  SALARY_CALCULATE_TABLE_DETAIL: '/salary-calculate-table-detail',
  SALARY_EXPENSE_EXPORT: '/salary-expense-export',
  SALARY_CALCULATE_IMPORT: '/salary-import',
  /* EMPLOYEE ASSIGN */
  EMPLOYEE_ASSIGN_MANAGEMENT: '/employee-assign-management',
  EMPLOYEE_ASSIGN_DETAIL: '/employee-assign-detail',
  EMPLOYEE_ASSIGN_IMPORT: '/employee-assign-import',
  /* APPROVE SALARY */
  APPROVE_SALARY_MANAGEMENT: '/approve-salary-management',
  APPROVE_SALARY_DETAIL: '/approve-salary-detail',
  /* PROJECT EMPLOYEE IMPORT */
  PROJECT_EMPLOYEE_IMPORT: '/project-employee-import',
  /* ATTENDANCE RECORDS IMPORT */
  ATTENDANCE_RECORDS_IMPORT: '/attendance-records-import',
  APPROVED_SALARY_MANAGEMENT: '/approved-salary-management',
  APPROVED_SALARY_DETAIL: '/approved-salary-detail',

  /* APPROVE HISTORY */
  APPROVE_HISTORY: '/approve-history',
  APPROVE_HISTORY_DETAIL: '/approve-history-detail',

  /* EXPORT REPORTS */
  EXPORT_SALARY_SUMMARY: '/export-salary-summary',
  PREVIEW_FILE: '/preview-file',

  /* EMPLOYEE ASSIGN */
  EMPLOYEE_FULLTIME_MANAGEMENT: '/employee-fulltime-management',
  EMPLOYEE_FULLTIME_DETAIL: '/employee-fulltime-detail',

  /* POSITION */
  POSITION_MANAGEMENT: '/position-management',
  POSITION_DETAIL: '/position-detail',
};

export const videoTypes: OptionType[] = [
  {
    label: 'Upload',
    value: 'upload',
  },
  {
    label: 'Youtube',
    value: 'youtube',
  },
  {
    label: 'Vimeo',
    value: 'vimeo',
  },
];

export const defaultSessionsCode = {
  hanoiCode: '1028580',
  sontayCode: '9074107',
  saigonCode: '1028581',
  danangCode: '1028809',
};

export const userLevelOptions: OptionType[] = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
];

export const typeRedeemOptions: OptionType[] = [
  {
    label: 'redeem.singleUse',
    value: 1,
  },
  {
    label: 'redeem.multiUses',
    value: 2,
  },
];

export const userTypeOptions: OptionType[] = [
  {
    label: 'New',
    value: 1,
  },
  {
    label: 'Current',
    value: 2,
  },
  {
    label: 'Cancel/Expired',
    value: 3,
  },
];

export const productTypeOptions: OptionType[] = [
  {
    label: 'OneTime',
    value: 1,
  },
  {
    label: 'Subscription',
    value: 2,
  },
];

export const promotionTypeOptions: OptionType[] = [
  {
    label: 'Discount',
    value: 1,
  },
  {
    label: 'Buy X Get Y',
    value: 2,
  },
];

export const discountTypeOptions: OptionType[] = [
  {
    label: 'Percent',
    value: 1,
  },
  {
    label: 'Fixed Amount',
    value: 2,
  },
];

export const durationTypeOptions: OptionType[] = [
  {
    label: 'Day',
    value: 1,
  },
  {
    label: 'Month',
    value: 2,
  },
];

export const codeTypeOptions: OptionType[] = [
  {
    label: 'One Time',
    value: 1,
  },
  {
    label: 'Multi Time',
    value: 2,
  },
];

export const dateDataOptions: OptionType[] = Array.from(
  { length: 31 },
  (_, index) => ({
    label: (index + 1).toString(),
    value: index + 1,
  })
);

export const monthDataOptions: OptionType[] = Array.from(
  { length: 12 },
  (_, index) => ({
    label: (index + 1).toString(),
    value: index + 1,
  })
);

export const funtionsOptions: OptionType[] = [
  {
    label: 'SolutionSearch',
    value: 'solutionSearch',
  },
  {
    label: 'HomeworkEvaluation',
    value: 'homeworkEvaluation',
  },
  {
    label: 'SimilarExercise',
    value: 'similarExercise',
  },
  {
    label: 'AiTutor',
    value: 'aiTutor',
  },
];

export const productDurations: OptionType[] = [
  {
    label: '7 days',
    value: 7,
  },
  {
    label: '30 days',
    value: 30,
  },
  {
    label: '90 days',
    value: 90,
  },
  {
    label: '180 days',
    value: 180,
  },
  {
    label: '365 days',
    value: 365,
  },
];

export const productDurationsExtend: OptionType[] = [
  ...productDurations,
  {
    label: 'Lifetime',
    value: -1,
  },
];

export const socialProviderOptions: OptionType[] = [
  {
    label: 'Facebook',
    value: 'facebook',
  },
  {
    label: 'Google',
    value: 'google',
  },
  {
    label: 'Twitter',
    value: 'twitter',
  },
  {
    label: 'Linkedin',
    value: 'linkedin',
  },
  {
    label: 'Microsoft',
    value: 'microsoft',
  },
  {
    label: 'Apple',
    value: 'apple',
  },
];

export const subscriptionStatusOptions: OptionType[] = [
  {
    label: 'Pending',
    value: 1,
  },
  {
    label: 'Active',
    value: 2,
  },
  {
    label: 'Expired',
    value: 3,
  },
  {
    label: 'Cancelled',
    value: 4,
  },
];

export const billingCycleOptions: OptionType[] = [
  {
    label: 'Weekly',
    value: 7,
  },
  {
    label: 'Monthly',
    value: 30,
  },
  {
    label: 'Quarterly',
    value: 90,
  },
  {
    label: 'Half Year',
    value: 180,
  },
  {
    label: 'Yearly',
    value: 365,
  },
  {
    label: 'Lifetime',
    value: -1,
  },
];

export const paymentPlatformOptions: OptionType[] = [
  {
    label: 'subscription.paypal',
    value: 1,
  },
  {
    label: 'subscription.apple',
    value: 2,
  },
  {
    label: 'subscription.google',
    value: 3,
  },
  {
    label: 'subscription.momo',
    value: 4,
  },
  {
    label: 'Activation Code',
    value: 5,
  },
];

export const paymentStatusOptions: OptionType[] = [
  {
    label: 'subscription.canceled',
    value: 1,
  },
  {
    label: 'subscription.failed',
    value: 2,
  },
  {
    label: 'subscription.paid',
    value: 3,
  },
  {
    label: 'subscription.suspended',
    value: 4,
  },
];

export const platformOptions: OptionType[] = [
  {
    label: 'ALL',
    value: 'ALL',
  },
  {
    label: 'IOS',
    value: 'IOS',
  },
  {
    label: 'ANDROID',
    value: 'ANDROID',
  },
  {
    label: 'WEB',
    value: 'WEB',
  },
];

export const contractTypeOptions = [
  {
    label: 'Part time',
    value: 1
  },
  {
    label: 'HDGV',
    value: 2
  }
];

export const ERR_UPLOAD_RES = {
  inValidSize: 'invalid size'
};

export const STATE_REDIRECT = {
  ADD_STAFF: 'ADD_STAFF'
};

export const LevelAPPRORVE = [
  'salary.creatorTableSalary',
  'salary.opCharge',
  'salary.acCharge',
  'salary.accounting',
  'Phụ trách'
];

export const handleStatusLabel = (status?: number) => {
  switch (status) {
    case 1:
      return 'salary.notApproved';
    case 2:
      return 'salary.approving';
    case 3:
      return 'salary.approved';
    case 4:
      return 'salary.refuse';
    case 5:
      return 'salary.reopen';
    default:
      return null;
  }
};

export const handleStatusHistoryLabel = (status?: boolean, isReopen?: boolean) => {
  if (isReopen) return 'salary.reopen';
  if (status) {
    return 'salary.approved';
  }
  return 'salary.refuse';
};

export const handleStatusApprovedLabel = (status?: number) => {
  switch (status) {
    case 1:
      return 'notApproved';
    case 2:
      return 'approving';
    case 3:
      return 'approved';
    case 4:
      return 'refuse';
    case 5:
      return 'reopen';
    default:
      return null;
  }
};

export const levelInChargeLabel = (level?: number) => {
  switch (level) {
    case 1:
      return 'system.supRole';
    case 2:
      return 'system.opRole';
    case 3:
      return 'system.acRole';
    case 4:
      return 'system.accountRole';
    default:
      return null;
  }
};

export const filterTypeExportOptions = [
  {
    label: 'Tháng',
    value: 5
  },
  {
    label: 'Năm',
    value: 6
  }
];

export const exportTypeOptions = [
  {
    label: 'exportReports.timeKeepingReport',
    value: 1
  },
  {
    label: 'exportReports.salaryReport',
    value: 2
  },
  {
    label: 'exportReports.otherBankInTCB',
    value: 3
  },
  {
    label: 'exportReports.TCBBankInTCB',
    value: 4
  },
  {
    label: 'exportReports.byMonthReport',
    value: 5
  },
  {
    label: 'exportReports.byYearReport',
    value: 6
  },
  {
    label: 'exportReports.salarySummaryReport',
    value: 7
  }
];

export const departmentStaffFulltimeOptions: OptionType[] = [
  {
    label: 'staffFulltime.account',
    value: 'account',
  },
  {
    label: 'staffFulltime.operation',
    value: 'operation',
  },
  {
    label: 'staffFulltime.ketoan',
    value: 'ketoan',
  },
  {
    label: 'staffFulltime.sup',
    value: 'sup',
  },
];

export const statusPayrollPeriodOptions = [
  {
    label: 'salary.calculateYet',
    value: 1
  },
  {
    label: 'salary.calculateDone',
    value: 2
  }
];

export const statusApproveOptions = [
  {
    label: 'salary.notApproved',
    value: 1
  },
  {
    label: 'salary.approving',
    value: 2
  },
  {
    label: 'salary.approved',
    value: 3
  },
  {
    label: 'salary.refuse',
    value: 4
  }
];

export const NoTaxCode = {
  label: 'Chưa có mã số thuế',
  value: 'Chưa có mã số thuế'
};

export const dateTransferOptions = [
  {
    label: 'approveSalary.spent',
    value: 1
  },
  {
    label: 'approveSalary.notSpent',
    value: 2
  },
];

export const Level = [
  {
    label: 'staffFulltime.sup',
    value: 1
  },
  {
    label: 'staffFulltime.operation',
    value: 2
  },
  {
    label: 'staffFulltime.account',
    value: 3
  },
  {
    label: 'staffFulltime.ketoan',
    value: 4
  },
  {
    label: 'staffFulltime.admin',
    value: 5
  },
];
